/**
 * @ngdoc service
 * @name profile
 *
 * @description Profile retriever service.
 */
module.factory('profile', ['drupal', 'lodash', '$q', function ($drupal, lodash, $q) {
    'use strict';

    var profile = {
        pending: null, // used to prevent multiple call (liveagent context)
        roles: {
            instructor: 'instructor',
            rtq: 'rtq',
            member: 'member',
            anonymous: 'anonymous'
        },
        /* data retriever */
        authorization: {
            authenticated: false,
            role: 'anonymous'
        },
        info: {},
        delivery: {},
        /* retrieve drupal's authenticated user */
        claim: function () {
            if (!profile.pending || profile.pending.promise.$$state.status != 0) {
                profile.pending = $q.defer();
                $drupal.retrieveProfile().then(function (data) {
                    profile.authorization.authenticated = data.authenticated;
                    profile.authorization.role = data.role;
                    profile.authorization.rtq = data.rtq;
                    angular.copy(data.info, profile.info);
                    angular.copy({}, profile.delivery);
                    profile.pending.resolve(profile.authorization);
                }).catch(function (error) {
                    profile.pending.reject(error);
                });
            }
            return profile.pending.promise;
        },
        /* dismiss drupal's authenticated user */
        dismiss: function () {
            return $drupal.releaseProfile().then(function () {
                profile.authorization.authenticated = false;
                profile.authorization.role = 'anonymous';
                angular.copy({}, profile.info);
                angular.copy({}, profile.delivery);
            });
        },
        /* amend profile with drupal approval */
        amend: function (infos) {
            return $drupal.updateAccount(this.info.field_sfid, infos).then(profile.claim);
        },
        /* return */
        isFullfilled: function () {
            return profile.info.field_nom &&
                profile.info.field_prenom &&
                profile.info.field_civilite &&
                profile.info.field_nationalite &&
                profile.info.field_tel_portable &&
                profile.info.field_adresse &&
                profile.info.field_cp &&
                profile.info.field_ville &&
                profile.info.field_pays;
        }
    };
    return profile;
}]);
